import * as Yup from 'yup';
import { SORTBY_OPTIONS, controllers } from '../../utils/constants';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const ControllerExperience = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const intl = useIntl();

  const controllersOptions = createLocalizedOptions(
    controllers,
    messages,
    SORTBY_OPTIONS.Name
  );

  useEffect(() => {
    const controllerExperienceSchema = {
      controllerIds: Yup.array(Yup.number()).min(
        1,
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(controllerExperienceSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="controllerIds"
      label={intl.formatMessage({ ...messages.controllers })}
      isMulti={true}
      options={controllersOptions}
      value={values.controllerIds}
      error={errors.controllerIds}
      setFieldValue={setFieldValue}
    />
  );
};

export default ControllerExperience;
